import { Component, OnInit } from '@angular/core';
import { Auth, ViewState} from 'src/common'
@Component({
  selector: 'app-role-details',
  templateUrl: './role-details.component.html'

})
export class RoleDetailsComponent  implements OnInit{

  viewState = ViewState;

  constructor() { }

  ngOnInit (): void {
    Auth.checkAuthorization('D04326D6-147C-461E-8EA1-7B22DF5F4A78');
  }
}
